module.exports = __webpack_public_path__ + "static/kafimola-d4369077e7b37d72177b4013989d5dda.jpg";